console.log("init Proteus treatments -- 1.05");

// small biz assist
if(window.location.href.indexOf("/pages/support-small") > -1 ||
document.querySelectorAll(".js-to--product-list").length > 0){
  waitForElement('body').then(doc => {
    doc.insertAdjacentHTML("afterbegin", `
      <style>
      .js-progressive-incentive{
        display: none !important;
      }
      </style>  
    `)
  }).catch();
}

observeSelector('.js-to--product-list--hero image-with-text-overlay', hero_img => {
  hero_img.insertAdjacentHTML("afterbegin", `

    <style>
    .js-to--product-list--hero .js-to--product-list {
      position: absolute;
      z-index: 3;
      top: 60.5%;
      left: 4.3%;
      width: 18%;
      height: 11%;
      line-height: 0;
      text-align: center;
      font-size: 1vw;
      white-space: nowrap;
    }
    @media (max-width: 999px) {
      .js-to--product-list--hero .js-to--product-list {
        top: 62.5%;
        left: 16.3%;
        width: 67.5%;
        height: 15.25%;
        font-size: 3vw;
      }
    }

    </style>

    <button class="button button--primary js-to--product-list">Shop the Bundle</button>`
  );
});

observeSelector('[href="#products-list"], .js-to--product-list', link_to_product_list => {

  link_to_product_list.addEventListener("click", (e) => {
    e.preventDefault();
    waitForElement('.featured-collections product-list').then(products_list => {
      
      const y = products_list.getBoundingClientRect().top + window.pageYOffset - 150; 
      window.scrollTo({
        top: y,
        behavior: 'smooth'
      });
      
    }).catch();
  });

});

// stay.ai mess
waitForElement('body').then(doc => {

  doc.insertAdjacentHTML("afterbegin", `
    <style>
      .lsg-bundle-interval-frequency-group-wrap .lsg-bundle-interval-frequency-select-wrap:nth-child(3),
      .lsg-bundle-interval-frequency-group-wrap .subsave-class:nth-child(4){

      }
    </style>  
  `);

}).catch();

// rtx content patch for subs on PDP
observeSelector('.rtx-subscription-label ul.subsave-class', sub_info => {
    sub_info.innerHTML = `
    <li>15% off every order</li>
    <li>Free U.S. Shipping</li>
    <li>15% Off Auto-Applied to Refills</li>
    <li>Modify, Pause, Cancel Any Time</li>
    <li>Early Access To Product Launches</li>
    `;
})

waitForElement('product-payment-container').then(pay => {
  pay.insertAdjacentHTML("beforebegin", `
    <style id="js-content-patch--rtx"></style>
  `);
  setInterval(() => {
    let skio = document.querySelector('skio-plan-picker')?.shadowRoot;
 
    if (skio?.querySelector('.group-container--selected .SubscriptionPurchase')) {
      let selling_plan = skio.querySelector('.selling-plan-dropdown option:checked')?.innerText || '';
      document.querySelector('#js-content-patch--rtx').innerHTML = `
        .combo-container{
          position: relative;
        }
        .product__info product-payment-container:after,
        .product-form product-payment-container:after{
          text-align: center;
          position: absolute;
          height: 3em;
          left: 0;
          bottom: -2rem;
          width: 100%;
          font-size: 12px;
          padding: .5rem;
          color: #000 !important;
          content: "Subscribe & Save - ${selling_plan.replace("Delivery", "Refill")} - 15% Off Every Order";
        }

        @media(max-width: 500px){
          shopify-payment-terms{
            padding-top: 1.5rem;
          }
        }
      `;
    } else {
      document.querySelector('#js-content-patch--rtx').innerHTML = ``;
    }

  }, 500)
}).catch();


// patch: disabled qty selector 
if(window.location.href.indexOf("/pages/bites") > -1){
  observeSelector('quantity-selector button', qty_btn => {
    qty_btn.removeAttribute("disabled");
  })
  waitForElement('#AddToCart').then(atc => {
    let atc_form = atc.closest("form");
    if(atc_form.querySelectorAll('input[name="quantity"]').length == 0){
      atc_form.insertAdjacentHTML("afterbegin", `<input type="hidden" name="quantity" value="1">`);
    }

    setInterval(() => {
      let qty_value = document.querySelector('quantity-selector input').value;
      atc_form.querySelector('input[name="quantity"]').value = qty_value;
    }, 500);

  }).catch();
}

// cart listener
(function () {

  var START_DELAY = 5000;
  var startTime = Date.now();
  var debounceTimer = null;

  var CART_REGEX = /\/cart\/(add|update|change|clear|js)/;

  function emitCartEvent(cart) {
    clearTimeout(debounceTimer);

    debounceTimer = setTimeout(function () {
      document.dispatchEvent(
        new CustomEvent("proteus:cart-changed", { detail: cart })
      );
    }, 100);
  }

  function shouldEmit(url) {
    if (!url) return false;

    if (Date.now() - startTime < START_DELAY) return false;

    return CART_REGEX.test(url);
  }

  function getUrl(input) {
    if (!input) return null;

    if (typeof input === "string") return input;

    if (input.url) return input.url;

    return null;
  }

  // -------------------------
  // FETCH PATCH
  // -------------------------

  if (window.fetch) {

    var originalFetch = window.fetch;

    window.fetch = function () {

      var args = arguments;
      var url = getUrl(args[0]);

      return originalFetch.apply(this, args).then(function (response) {

        if (shouldEmit(url)) {

          try {

            response.clone().json().then(function (cart) {
              emitCartEvent(cart);
            }).catch(function(){});

          } catch(e) {}

        }

        return response;

      });

    };

  }

  // -------------------------
  // XHR PATCH
  // -------------------------

  if (window.XMLHttpRequest) {

    var originalOpen = XMLHttpRequest.prototype.open;

    XMLHttpRequest.prototype.open = function (method, url) {

      if (shouldEmit(url)) {

        this.addEventListener("load", function () {

          try {

            var data = JSON.parse(this.responseText);
            emitCartEvent(data);

          } catch(e) {}

        });

      }

      return originalOpen.apply(this, arguments);

    };

  }

})();


// support for re-targeting
if(window.location.href.indexOf("/collections/all-products") > -1){
  // shop all collection
  if(window.location.href.toLowerCase().indexOf("utm=lp-blah-blah") > -1 ||
  window.location.href.toLowerCase().indexOf("#progsale") > -1 ||
  window.location.href.toLowerCase().indexOf("utm=progsale") > -1 ||
  window.location.href.toLowerCase().indexOf("utm_campaign=progsale") > -1 ||
  window.sessionStorage.getItem("DTC treatment active")){
    
    window.sessionStorage.setItem("DTC treatment active", true)
    window.localStorage.setItem("[IQB-03] // 1.0", 1)

    observeSelector('[data-product-title="Ultimate Sampler (9 Bars + 12 Sticks)"], [product-handle="7-bar-trial"], [data-product-title="8 Flavor Variety"], [data-product-title="IQJOE Original Variety (16 Sticks)"]', sampler => {
      sampler.closest('section.section').style.display = "none";
    });

    waitForElement('.video-section.video-section--full').then(hero_video => {
      hero_video.classList.add("js-video--swap");
      hero_video.insertAdjacentHTML("afterbegin", `
      <style>
      .js-video--swap native-video,
      .js-video--swap img{
        display: none;
      }
      
      @media(min-width: 1200px){
        img.js-desktop{
          display: block;
        }
      }

      @media(max-width: 1200px) and (min-width: 768px){
        img.js-tablet{
          display: block;
        }
      }

      @media(max-width: 768px){
        img.js-mobile{
          display: block;
        }
      }

      </style>  
      <img class="js-desktop" src="https://cdn.shopify.com/s/files/1/1682/9837/files/Desktop---Collections-Page-Banner-5289x1085_1.jpg?v=1772127903&width=2800" />
      <img class="js-tablet" src="https://cdn.shopify.com/s/files/1/1682/9837/files/Tablet---Collections-Page-Banner-6000x1622_1.jpg?v=1772127903&width=1800" />
      <img class="js-mobile" src="https://cdn.shopify.com/s/files/1/1682/9837/files/Mobile---Collections-Page-Banner-1600x2465_1.jpg?v=1772127903&width=1200" />
      `);

    }).catch();

    /*
    waitForElement('multi-column').then(links => {
      links.insertAdjacentHTML("beforebegin", `
        <div style="max-width: 500px; width: 100%; margin: 0 auto 2rem auto; text-align: center;">
          Save more when you mix and match<br>(track your progress in-cart)
        </div>  
      `)
    })
    */
  }
}


const modify_sub = async (selling_plan_id, element) => {
  
  let line_key = element.getAttribute("key");
  let qty = parseInt(element.getAttribute("qty"));
  let var_id = element.getAttribute("var_id");

  console.log("adjust_sub()", line_key, qty, var_id, selling_plan_id);

  if (!line_key || !var_id || !selling_plan_id || !qty) return;

  const delay = (ms) => new Promise(res => setTimeout(res, ms));

  try {
    // 1️⃣ Remove existing line
    const removeRes = await fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        id: line_key,
        quantity: 0,
      }),
    });

    if (!removeRes.ok) throw new Error("Remove failed");

    // 🔥 wait for Shopify to settle
    await delay(150); // 100–300ms sweet spot

    // 2️⃣ Add with selling plan
    const addRes = await fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        id: var_id,
        quantity: qty,
        selling_plan: selling_plan_id,
      }),
    });

    if (!addRes.ok) throw new Error("Add failed");

    console.log("re-added sub");

    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
      bubbles: true
    }));

  } catch (err) {
    console.error("Subscription swap failed", err);
  }
  
};

observeSelector('.cart_item_selling_plan', selling_plan => {

  selling_plan.addEventListener("change", (e) => {
    let selling_plan_id = e.target.value;
    modify_sub(selling_plan_id, e.target);
  });

});

observeSelector('.js-convert-to-sub', convert_to_sub => {

  convert_to_sub.addEventListener("click", (e) => {
    let selling_plan_id = convert_to_sub.getAttribute("plan_id");
    modify_sub(selling_plan_id, e.target);
  });

})

async function submitVariantViaProductForm(variantId, qty = 1) {
  const form = document.getElementById("hidden-product-form");
  if (!form) throw new Error("Hidden product form missing");

  // fill inputs
  form.querySelector('input[name="id"]').value = String(variantId);
  form.querySelector('input[name="quantity"]').value = String(qty);

  // wrap the event-driven flow in a Promise so we can await completion
  const done = new Promise((resolve) => {
    const onRefresh = (e) => {
      // product-form will dispatch cart:refresh with sections; resolve after it fires
      document.documentElement.removeEventListener("cart:refresh", onRefresh);
      resolve(e.detail);
    };
    document.documentElement.addEventListener("cart:refresh", onRefresh, { once: true });
  });

  // triggers ProductForm._onSubmit -> theme ajax add + events
  form.requestSubmit();

  return done; // resolves with the cart:refresh detail
}

// atc links -- #atc--12345678-3456789
observeSelector('[href*="#atc--"]', atc_link => {

  if(document.querySelectorAll(`#hidden-product-form`).length == 0){
    document.querySelector('body').insertAdjacentHTML("beforeend", `
    <form is="product-form"
      id="hidden-product-form"
      action="/cart/add"
      method="post"
      style="display:none">
      <input type="hidden" name="id" value="">
      <input type="hidden" name="quantity" value="1">
    </form>  
    `);
  }

  atc_link.addEventListener("click", async (e) => {

    let atc_href = e.currentTarget.getAttribute("href");
    const match = atc_href.match(/#atc--([\d\-]+)/);
    if (!match) return;

    const var_ids = match[1].split("-"); // ["12345678", "3456789"]

    // Build items array for cart/add.js
    const items = var_ids.map(id => ({
      id,
      quantity: 1
    }));

    try {
      const res = await fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ items })
      });
      const data = await res.json();
      console.log("Added multiple items:", data);

      waitForElement('#mini-cart').then(cart => {
        if(cart.open){
          cart.open = false;
        }

        setTimeout(() => {
          document.querySelector('a[href="/cart"][is="toggle-link"]').click();
        }, (500));

        setTimeout(() => {
          document.querySelector('a[href="/cart"][is="toggle-link"]').click();
          setTimeout(() => {
            document.querySelector('a[href="/cart"][is="toggle-link"]').click();
          }, (50));
        }, (2500));

      }).catch();

    } catch (err) {
      console.error("ATC error", err);
    }
  });
})

// joe: 40216908529798
// bar: 40216907939974

//
// START support for [IQB-02]
//

waitUntil(() => {
  return window.location.href.indexOf("qa=stayai") > -1 || window.sessionStorage.getItem("[IQB-02]");
}).then(() => {

  console.log("init [IQB-02] v1");

  const var_id = 42412052349062;
  const selling_plan_id = '5478088838';
  const custom_props = {
    '_source': '[IQB-02]'
  };

  waitForElement('body').then(doc => {
    doc.insertAdjacentHTML("afterbegin", `
    <style>
    [data-slidecart-item="${var_id}"],
    line-item[data-var-id="${var_id}"]{
      display: none !important;
    }
    </style>  
    `);
  })

  window.sessionStorage.setItem("[IQB-02]", true);
  console.log(`init Stay.ai treatment`);

  const random_number = Math.floor(Math.random() * 1001);

  const review_cart = () => {
    console.log("review_cart()");

    fetch('/cart.js').then(res => res.json()).then(cart => {

      window.cart_data = cart;

      const anySellingPlanExists = cart.items.some(item => !!item.selling_plan_allocation);
      const hasThatVariant = cart.items.some(item => (item.variant_id ?? item.id) === Number(var_id));
      
      const target_prod_ids = [6738720358534, 4425539977350, 6648412045446, 6875386839174]; // 4 sample products
      const hasSpecificProduct = cart.items.some(item =>
        target_prod_ids.includes(Number(item.product_id))
      );

      console.log("hasThatVariant", hasThatVariant, "hasSpecificProduct", hasSpecificProduct);


      // if (!hasThatVariant && cart.items.length > 0) {
      if (!hasThatVariant && hasSpecificProduct) {

        console.log("add item");

        // Otherwise, add to cart and then checkout
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            id: var_id,
            quantity: 1,
            properties: custom_props,
            selling_plan: selling_plan_id
          })
        }).then(res => res.json()).then(data => {

          console.log('Item added to cart:', data);
          // window.location.href = "/checkout";
        });
      }

    }).catch(err => {
      console.error('Cart fetch or ATC failed:', err);
    });

  }; // review_cart()

  review_cart();

  /*
  var_ids: 
  40172370690182 -- iqjoe-original-variety-16-sticks
  39796293861510 -- ultimate-sampler
  39589852184710 -- 8-flavor-variety
  31461251874950 -- 7-bar-trial
  */

  function debounce(fn, delay) {
    let timeout;
    return (...args) => {
      clearTimeout(timeout);
      timeout = setTimeout(() => fn(...args), delay);
    };
  }

  const debouncedReviewCart = debounce(review_cart, 500);

  observeSelector('line-item[data-var-id]', cart_item => {
    if(document.querySelectorAll('line-item[data-var-id="40172370690182"], line-item[data-var-id="39796293861510"], line-item[data-var-id="39589852184710"], line-item[data-var-id="31461251874950"]').length > 0){
      debouncedReviewCart();
    }
  });

}).catch();

//
// END support for [IQB-02]
//

//
// START support for PP Offers
//

// support for proteus pp_offers
window.pp_active = true;
if(window.location.href.indexOf("qa=pp") > -1 || window.pp_active){
  window.sessionStorage.setItem("Proteus PP QA", true);
}

const push_pp_offers = () => {
  if(window.sessionStorage.getItem("Proteus pp-session-id") && window.cart_pp_offers.length > 0){

    // window.cart_pp_offers = [];
    if(window.location.href.indexOf("new_pp") > -1){
      window.cart_pp_offers = window.cart_pp_offers_new
    }

    let session_id = window.sessionStorage.getItem("Proteus pp-session-id");
    fetch("https://proteus-iqbar.fly.dev/api/pp_offers", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
        referenceId: session_id,
        offers: window.cart_pp_offers
      })
    }).then(res => res.json()).then(console.log).catch(console.error);

  }
};

waitUntil(() => {
  return typeof window.cart_pp_offers != "undefined" && window.cart_pp_offers.length > 0;
}).then(() => {

  if(!window.sessionStorage.getItem("Proteus pp-session-id") && window.sessionStorage.getItem("Proteus PP QA")){
    let pp_session_id = "pp-";
    for (let i = 0; i < 16; i++) {
      pp_session_id += Math.floor(Math.random() * 10);
    }
    window.sessionStorage.setItem("Proteus pp-session-id", pp_session_id)
    setTimeout(() => {
      gtm_add_cartAttribute("pp-session-id", pp_session_id);
    }, 2500); // delay to reduce API clogging
  }

  push_pp_offers();

}).catch();

/*
// TODO: this call intercept works fine, maybe just make it a little less bloated
(function() {
  const originalFetch = window.fetch;

  window.fetch = async function(...args) {
    const response = await originalFetch.apply(this, args);

    const url = args[0];

    if (typeof url === "string" && url.includes("/cart/")) {
      response.clone().json().then(cart => {
        document.dispatchEvent(
          new CustomEvent("proteus:cart-changed", { detail: cart })
        );
      }).catch(() => {});
    }

    return response;
  };
})();

document.addEventListener("proteus:cart-changed", (e) => {
  console.log("Cart updated", e.detail);
});
*/

document.addEventListener("proteus:cart-changed", (e) => {
  // console.log("proteus: cart updated", e.detail);
  window.cart_data = e.detail;

  // The fetch hook dispatches this event with ANY /cart/* response body — including
  // error payloads (422s have no `items`) and empty carts. Guard both: the offers API
  // 500s on an empty `ids=` param, and `items` may be missing entirely.
  const cart_items = (e.detail && Array.isArray(e.detail.items)) ? e.detail.items : [];
  let cart_prod_ids = [];
  for(let i = 0; i < cart_items.length; i++){
    if (cart_items[i].product_id) cart_prod_ids.push(cart_items[i].product_id);
  }
  if (cart_prod_ids.length === 0) return;

  get_proteus_product_data(cart_prod_ids.toString()).then(response => {
    console.log("get_proteus_product_data", response)
    window.staged_pp_offers = response.offers || [];
    
    window.cart_pp_offers = [];
    for(let i = 0; i < window.staged_pp_offers.length; i++){

      let discount_amount = window.staged_pp_offers[i].changes[0].discount.value;
      let discount_type = window.staged_pp_offers[i].changes[0].discount.valueType;

      let content_compare_at = window.staged_pp_offers[i].content_compare_at;
      let content_offer_price = window.staged_pp_offers[i].content_offer_price;

      if(window.staged_pp_offers[i].content_products.length > 0){
        
        content_compare_at = parseFloat(window.staged_pp_offers[i].content_products[0].variants.edges[0].node.price).toFixed(2);
        if (discount_type === "percentage") {
          content_offer_price = parseFloat(
            (content_compare_at * (1 - discount_amount / 100)).toFixed(2)
          );
        } else {
          content_offer_price = parseFloat(
            (content_compare_at - discount_amount).toFixed(2)
          );
        }

      }

      window.cart_pp_offers.push({

        pp_offer_type: window.staged_pp_offers[i].def_type,
        pp_offer_new_qty: window.staged_pp_offers[i].def_quantity,
        pp_offer_new_interval: window.staged_pp_offers[i].ref_new_interval,
        pp_offer_id: window.staged_pp_offers[i].def_offer_id,
        pp_offer_banner_title: window.staged_pp_offers[i].content_banner_title,
        pp_offer_banner_subtitle: window.staged_pp_offers[i].content_banner_subtitle,
        pp_offer_title: window.staged_pp_offers[i].content_title,
        pp_offer_image_url: window.staged_pp_offers[i].content_images[0],
        pp_offer_description: [window.staged_pp_offers[i].content_description],
        pp_offer_compare_at: content_compare_at,
        pp_offer_price: content_offer_price,
        changes: window.staged_pp_offers[i].changes,

      });

    }

    push_pp_offers();

  }).catch((err) => {
    console.warn("proteus: offers unavailable", err);
  })
});

async function get_proteus_product_data(prod_ids) {
  console.log("get_proteus_product_data()");
  // could potentially do this via Shopify REST API
  const response = await fetch(`https://proteus-iqbar.fly.dev/api/catalog?lookup=product_offers&ids=${prod_ids}`);

  if (!response.ok) {
    throw new Error(`HTTP ${response.status}`);
  }

  const data = await response.json();
  return data;
}

//
// END support for PP Offers
//

async function apply_discount(code) {
  console.log("apply_discount()", code)
  const response = await fetch(`/discount/${encodeURIComponent(code)}`, {
    method: "GET",
    credentials: "same-origin",
    redirect: "follow"
  });

  document.dispatchEvent(new CustomEvent("cart:refresh"));
}

if(window.location.href.indexOf("/pages/aj-big-justice") > -1 ||
window.sessionStorage.getItem("boom15 active")){

    waitForElement('image-with-text-overlay').then(hero_img => {
      hero_img.classList.add("js-hero-img")
      hero_img.insertAdjacentHTML("beforebegin", `
        <style>
        @media(max-width: 768px){
          #main image-with-text-overlay.js-hero-img{
            height: calc(275px + 90vw) !important;
          }
        }  

        @media(max-width: 435px){
          #main image-with-text-overlay.js-hero-img{
            height: calc(315px + 90vw) !important;
          }
        }  
        </style>
      `);
    })

    waitForElement('.product__info .price').then(price => {
      price.innerHTML = `<s style="opacity: .35;">$24.99</s> $21.25`;
    }).catch();

    window.sessionStorage.setItem("boom15 active", true)
    window.localStorage.setItem("[IQB-03] // 1.0", 0);
    window.localStorage.setItem("[IQB-03] // 2.0", 0);

    setTimeout(() => {
      apply_discount("BOOM15")
    }, 1500);

    document.addEventListener("DOMContentLoaded", (() => {
      apply_discount("BOOM15")
    }))



}